import type {
  DistrictAndBuildingsOptions
} from '../models/requestObjects/AnnualPlanResponseObjects'
import { useEffect, useState } from 'react'
import { GetEEMDistrictsAndBuildingsForPlanOrganization } from '../services/AnnualPlanService'
import { handleApiResponse } from '../utils/apiHelpers'

interface UseEEMDistrictAndBuildingsOptionsType {
  districtAndBuildingsOptions: DistrictAndBuildingsOptions[]
  isLoading: boolean
}

export const useEEMDistrictAndBuildingsOptions = (planOrgId: number): UseEEMDistrictAndBuildingsOptionsType => {
  const [districtAndBuildingsOptions, setDistrictAndBuildingsOptions] = useState<DistrictAndBuildingsOptions[]>([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const getDistrictAndBuildingsOptions = async (): Promise<void> => {
      setIsLoading(true)
      const districtAndBuildingsOptions = await handleApiResponse(GetEEMDistrictsAndBuildingsForPlanOrganization(planOrgId))
      if (districtAndBuildingsOptions != null) setDistrictAndBuildingsOptions(districtAndBuildingsOptions)
      setIsLoading(false)
    }

    void getDistrictAndBuildingsOptions()
  }, [planOrgId])

  return { districtAndBuildingsOptions, isLoading }
}
